import React from 'react';
import { Navigate } from 'react-router-dom';

// Route for organization users only
function OrgRoute({ children }) {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  if (!token) return <Navigate to="/registration" replace />;
  
  const isOrg = user.accountType === 'organization' || user.userType === 'organizer' || user.role === 'organizer';
  const isAdmin = user.role === 'admin';
  
  if (!isOrg && !isAdmin) return <Navigate to="/" replace />;
  
  return children;
}

export default OrgRoute;
